import decryptCode from "../../utils/decryptCode";
import { getNameseoByRadioid } from "../../hooks/useApi";

export const parseRedeemCodeParam = (code) => {
  if (code === "code") {
    const paramCode = new URLSearchParams(window.location.search).get("c");
    return paramCode ? decodeURIComponent(paramCode) : null;
  }

  return code ? decodeURIComponent(code) : null;
};

export const resolveRedeemCode = async (encodedCode) => {
  if (!encodedCode) {
    throw new Error("Missing redeem code");
  }

  const decrypted = decryptCode(encodedCode);
  const parts = decrypted.split("-");
  const code = parts[0] ?? null;
  const radioid = parts.length > 1 ? parts[1] : null;

  if (!code) {
    throw new Error("Invalid redeem code");
  }

  let nameseo = null;
  if (radioid) {
    nameseo = await getNameseoByRadioid(radioid);
  }

  if (!radioid || !nameseo) {
    throw new Error("Redeem code has no radio context");
  }

  return {
    encodedCode,
    code,
    radioid,
    nameseo,
  };
};

export const resolveEntryTarget = async ({ source, nameseo, code }) => {
  if (source === "redeem") {
    const encodedCode = parseRedeemCodeParam(code);
    const redeem = await resolveRedeemCode(encodedCode);

    return {
      nameseo: redeem.nameseo,
      radioid: redeem.radioid,
      redeem,
    };
  }

  return {
    nameseo,
    radioid: null,
    redeem: null,
  };
};
